import Page from 'Component/common/udesk-qa-page-layout';
import React, { useEffect, useMemo, useState } from 'react';
import { getKcsConfigs, postKcsConfigs } from 'src/api/kcsConfigs';
import { putKcsConfigsById } from 'src/api/kcsConfigs/{id}';
import { KcsConfigFoundResponse } from 'src/api/types';
import Udesk from 'Udesk';
import { Button, Col, FormBuilder, Row, Space } from 'udesk-ui';
import type { FormProps } from 'udesk-ui/lib/form-builder/types/form';
import UdeskLocales from 'UdeskLocales';

const Display = (props) => <div>{props.value ?? ''}</div>;

const KcsDocking = (props) => {
    const locales = UdeskLocales['current'];

    const [initialValues, setInitialValues] = useState<KcsConfigFoundResponse>({});
    const [initialForm] = FormBuilder.useForm();
    const [loading, setLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);

    const initialFormFields: FormProps['fields'] = [
        {
            name: 'interfaceUrl',
            type: 'Input',
            label: /* 接口URL */ UdeskLocales['current'].pages.systemIntegration.kcsDocking.index
                .interfaceURL,
            rules: [
                {
                    required: true,
                },
            ],
            props: {
                placeholder: locales.labels.pleaseEnter,
            },
        },
        {
            name: 'token',
            type: 'Input',
            label: 'token',
            rules: [
                {
                    required: true,
                },
            ],
            props: {
                placeholder: locales.labels.pleaseEnter,
            },
        },
        {
            name: 'publicKey',
            type: 'Input',
            label: /* 公钥 */ UdeskLocales['current'].pages.systemIntegration.kcsDocking.index
                .publicKey,
            rules: [
                {
                    required: true,
                },
            ],
            props: {
                placeholder: locales.labels.pleaseEnter,
            },
        },
        {
            name: 'secretKey',
            type: 'Input',
            label: /* 私钥 */ UdeskLocales['current'].pages.systemIntegration.kcsDocking.index
                .privateKey,
            rules: [
                {
                    required: true,
                },
            ],
            props: {
                placeholder: locales.labels.pleaseEnter,
            },
        },
    ];
    const formConfigs = useMemo(() => getConfig(initialFormFields, initialValues), [initialValues]);

    const cancel = () => {
        initialForm.resetFields();
    };

    const save = async (values) => {
        setBtnLoading(true);
        if (initialValues?.id) {
            putKcsConfigsById(values, {
                segments: {
                    id: initialValues.id,
                },
                successMsg: locales.business.info.saveSuccess,
            });
        } else {
            postKcsConfigs(values, {
                successMsg: locales.business.info.saveSuccess,
            });
        }
        setInitialValues({ ...initialValues, ...values });
        setBtnLoading(false);
    };
    useEffect(() => {
        setLoading(true);
        getKcsConfigs().then(
            (resp) => {
                setInitialValues(resp?.data ?? {});
                setLoading(false);
            },
            (reason) => {
                Udesk.ui.notify.error(
                    reason.errorMsg ||
                        locales.components.pages.components.recordDetail.getDetailFailed
                );
                setLoading(false);
            }
        );
    }, []);

    useEffect(() => {
        cancel();
    }, [initialValues]);

    return (
        <Page
            pageBodyClassName="wechat-docking-page-index"
            title={locales.pages.admin.wechatDocking.title}
            loading={loading}
        >
            <FormBuilder onFinish={save} form={initialForm} {...formConfigs}></FormBuilder>
            <Row>
                <Col offset={7}>
                    <Space>
                        <Button loading={btnLoading && { delay: 200 }} onClick={cancel}>
                            {locales.labels.cancel}
                        </Button>
                        <Button
                            loading={btnLoading && { delay: 200 }}
                            type="primary"
                            onClick={() => initialForm.submit()}
                        >
                            {locales.labels.save}
                        </Button>
                    </Space>
                </Col>
            </Row>
        </Page>
    );
};

class Component extends React.Component {
    render() {
        return <KcsDocking {...this.props} />;
    }
}

export default Udesk.react.udeskify(Component);

const configTemplate: Omit<FormProps, 'fields'> = {
    footerRender: false,
    customComponents: { Display },
};

function getConfig(fields, initialValues) {
    return {
        ...configTemplate,
        fields,
        initialValues,
    };
}
